module.exports = __webpack_public_path__ + "img/qrcode_for_gh_06bd09b5becf_344.5212ea11.jpg";